import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIR } from 'types/wellGuardian';

import { getEngineeringWorkSections } from './getEngineeringWorkSections';
import { getFinalPreparationSections } from './getFinalPreparationSections';
import { getFinalWirSections } from './getFinalWirSections';
import { getInterventionCloseOutSections } from './getInterventionCloseOutSections';
import { getInterventionOperationSections } from './getInterventionOperationSections';
import { getKomTechnicalWirSections } from './getKomTechnicalWirSections';
import { getReactiveScopeSections } from './getReactiveScopeSections';
import { getWirCreatedSections } from './getWirCreatedSections';
import { getWirStageGate1Sections } from './getWirStageGate1Sections';
import { getWirStageGate2Sections } from './getWirStageGate2Sections';
import { getWirStageGate3Sections } from './getWirStageGate3Sections';
import { getWirStageGate4Sections } from './getWirStageGate4Sections';
import { getWirStageGate5Sections } from './getWirStageGate5Sections';

export const getAllSections = (wir: WIR | null, country: string) => {
  // UnitedKingdom, Nigeria, Angola, Congo
  const isUnplannedReactiveScope = getIsUnplannedReactiveScope(wir);
  const reactiveScopeSections = getReactiveScopeSections(wir, country);
  const wirCreatedSections = getWirCreatedSections(wir, country);
  const wirEngineeringWorkSections = getEngineeringWorkSections(wir, country);
  const komTechnicalWirSections = getKomTechnicalWirSections(wir, country);
  const finalWirSections = getFinalWirSections(wir, country);
  const finalPreparationSections = getFinalPreparationSections(wir, country);
  const interventionOperationSections = getInterventionOperationSections(wir, country);
  const interventionCloseOutSections = getInterventionCloseOutSections(wir, country);
  // Denmark
  const stageGate1 = getWirStageGate1Sections(wir);
  const stageGate2 = getWirStageGate2Sections(wir);
  const stageGate3 = getWirStageGate3Sections(wir);
  const stageGate4 = getWirStageGate4Sections(wir);
  const stageGate5 = getWirStageGate5Sections(wir);

  return [
    // UnitedKingdom, Nigeria, Angola, Congo
    ...(isUnplannedReactiveScope ? reactiveScopeSections : []),
    ...(isUnplannedReactiveScope ? [] : wirCreatedSections),
    ...(isUnplannedReactiveScope ? [] : komTechnicalWirSections),
    ...(isUnplannedReactiveScope ? [] : wirEngineeringWorkSections),
    ...(isUnplannedReactiveScope ? [] : finalWirSections),
    ...(isUnplannedReactiveScope ? [] : finalPreparationSections),
    ...interventionOperationSections,
    ...interventionCloseOutSections,
    // Denmark
    ...stageGate1,
    ...stageGate2,
    ...stageGate3,
    ...stageGate4,
    ...stageGate5,
  ];
};
